"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractsVersion = void 0;
exports.contractsVersion = '2.3.0';
